/*
 * @Author: your name
 * @Date: 2021-04-27 10:12:02
 * @LastEditTime: 2021-05-27 19:04:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /hdl-open-pc/src/router/index.tsx
 */
import React, { Suspense } from 'react'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'
import Loading from '../pages/Loading'
import NoFound from '../pages//NoFound'
const Login = React.lazy(() => import(/*webpackChunkName:"login" */ '../pages/Login'));
const Home = React.lazy(() => import(/*webpackChunkName:"home" */ '../pages/Home'));
const Users = React.lazy(() => import(/*webpackChunkName:"docs" */ '../pages/Users'));
const Docs = React.lazy(() => import(/*webpackChunkName:"docs" */ '../pages/Docs'));
const Register = React.lazy(() => import(/*webpackChunkName:"register" */ '../pages/Register'));
// const NewRegister = React.lazy(() => import(/*webpackChunkName:"home" */ '../pages/Register'));

interface Iprops {
  name: string
}

const App: React.FC<Iprops> = function (props) {
  return <HashRouter>
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path="/" component={Home} exact></Route>
        <Route path="/login" component={Login} ></Route>
        <Route path="/register" component={Register}></Route>
        {/* <Route path="/newRegister" component={NewRegister}></Route> */}
        <Route path="/users" component={Users}></Route>
        <Route path="/docs" component={Docs}></Route>
        <Route path='/404' component={NoFound}></Route>
        <Redirect path='/*' to='/404' ></Redirect>
      </Switch>
    </Suspense>
  </HashRouter>
}

export default App